
const features = [
  {
    icon: 'ri-spine-line',
    title: '人間工学設計',
    description: '人体の自然なカーブに沿った設計で、長時間のデスクワークでも体への負担を最小限に抑えます。',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'マルチアジャスト',
    description: 'ヘッドレスト、アームレスト、ランバーサポート、座面など多数の調整ポイントで最適なポジションを実現。',
  },
  {
    icon: 'ri-leaf-line',
    title: '通気性メッシュ',
    description: '高密度メッシュ素材を採用し、長時間座っていても蒸れにくく快適な座り心地を維持します。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '高耐久設計',
    description: '最大150kgの耐荷重と厳格な品質テストをクリア。長く安心してお使いいただけます。',
  },
  {
    icon: 'ri-volume-mute-line',
    title: '静音キャスター',
    description: 'フローリングにも優しい静音設計のキャスターで、集中を妨げません。',
  },
  {
    icon: 'ri-palette-line',
    title: '2カラー展開',
    description: 'Black / Gray の2色展開。どんなワークスペースにも馴染むミニマルなカラーリング。',
  },
];

export default function ChairLineupFeatures() {
  return (
    <section className="py-20 sm:py-28 bg-white" aria-labelledby="features-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-12 sm:mb-16">
          <h2
            id="features-heading"
            className="text-3xl sm:text-4xl md:text-5xl font-extralight text-black mb-4 tracking-[0.1em]"
          >
            Designed for Focus
          </h2>
          <p className="text-sm sm:text-base font-extralight text-black/50 tracking-wide max-w-xl mx-auto">
            全モデル共通のこだわり
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 md:gap-8" role="list">
          {features.map((feature, index) => (
            <article
              key={index}
              className="p-6 sm:p-8 bg-gray-50 rounded-xl hover:bg-gray-100/80 transition-colors duration-300"
              role="listitem"
            >
              <div className="w-11 h-11 sm:w-12 sm:h-12 flex items-center justify-center bg-[#8E7AB5]/10 rounded-lg mb-4">
                <i className={`${feature.icon} text-xl sm:text-2xl text-[#8E7AB5]`} aria-hidden="true"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-light text-black mb-2 tracking-wide">
                {feature.title}
              </h3>
              <p className="text-sm font-extralight text-black/50 leading-relaxed tracking-wide">
                {feature.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
